module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-lg-7\"> <div class=\"ending-in\"> ")
    ;  if (locals.brandImgClass !== 'unknown-cc') { 
    ; __append(" <span class=\"credit-card ")
    ; __append(escapeFn( locals.brandImgClass ))
    ; __append("\"></span> ")
    ;  } else { 
    ; __append(" <span class=\"glyphicon glyphicon-credit-card credit-card\"></span> ")
    ;  } 
    ; __append(" ending in <strong>")
    ; __append(escapeFn( locals.last4 ))
    ; __append("</strong> </div> <dl class=\"inline-definition-list\"> <dt>Name on Card:</dt> <dd>")
    ; __append(escapeFn( locals.name ))
    ; __append("</dd><br> <dt>Expires on</dt> <dd>")
    ; __append(escapeFn( locals.exp_month + " / " + locals.exp_year ))
    ; __append("</dd><br> </dl> </div> <div class=\"col-lg-5\"> <a href=\"#\" class=\"one-time-charge btn btn-blue btn-block\">One-Time Charge</a> <a href=\"#\" class=\"remove_card btn btn-red btn-block\">Remove Card</a> </div> </div> <div class=\"recharge_settings\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/credit_card_details.ejs
// module id = 886
// module chunks = 1